import {$get} from "../../core/js/Ajax.ts";
import {$, $$} from "../../core/js/Dom.ts";

function charge_panels(panel: HTMLElement | null, focus = null) {
    if (!panel) {
        panel = $('.fr-tabs__tab--active')
    }
    if (panel) {
        let pk = panel.dataset.pk
        let id = panel.getAttribute('id')
        let url = focus ? `/aide/panel/${pk}/?focus=${focus}` : `/aide/panel/${pk}/`
        const content = $<HTMLElement>(`#panel-${id}`)!
        if($('.blocs-chargement-spinner', content)) {
            $get(url).then(({body}) => {
                if (content) content.innerHTML = body

                const accordion = window.location.pathname.split('/').pop()
                if (accordion && !isNaN(Number(accordion))) {
                    requestAnimationFrame(() => {
                        const accordionElement = $(`[aria-controls="accordion-${pk}-${accordion}"]`)
                        accordionElement?.click()
                        // commenter car cause le bug de disparition des onglets: https://openscop.dev/openscop/dematerialisation-manifestation-sportive/-/issues/822
                        // accordionElement?.scrollIntoView()
                    })
                }
                document.dispatchEvent(new CustomEvent('aide:loaded'))
            })
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    if (document.body.dataset.url?.startsWith('page-aide')) {
        const panels = $$<HTMLElement>('.fr-tabs__tab')
        panels.forEach((panel) => {
            panel.addEventListener('focusin', () => {
                charge_panels(panel)
            })
        })
        charge_panels(null, window.Openscop.aide_focus)
    }
})